<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm" (click)="onCancel()">
  <div
    class="w-full max-w-[600px] rounded-lg bg-white p-5 shadow-xl"
    (click)="$event.stopPropagation()"
    [formGroup]="assignForm">
    <div class="mb-4 flex items-center justify-between">
      @if (type() === "assign") {
        <h2 class="text-xl font-bold text-gray-900" i18n="@@adminAssignEmployeeTitle">Assign Employee</h2>
      }
      @if (type() === "re-assign") {
        <h2 class="text-xl font-bold text-gray-900" i18n="@@adminReassignEmployeeTitle">Re-assign Employee</h2>
      }
      <button
        (click)="onCancel()"
        class="cursor-pointer rounded border border-gray-700 p-1 text-gray-500 hover:text-gray-700">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>

    <div class="mb-5">
      @if (type() === "assign") {
        <p class="mb-3 text-sm" i18n="@@adminAssignEmployeeMessage">
          Assigning employee for
          <span class="font-medium text-gray-900">{{ nickname() }}</span>
        </p>
      }
      @if (type() === "re-assign") {
        <p class="mb-3 text-sm" i18n="@@adminReassignEmployeeMessage">
          Re-assigning employee for
          <span class="font-medium text-gray-900">{{ nickname() }}</span>
        </p>
      }

      @if (context() === "approved-pharmacy") {
        <label class="textTapsColor mb-1 block cursor-pointer font-medium" i18n="@@teleSalesLabel">Tele Sales *</label>
      } @else {
        <label class="textTapsColor mb-1 block cursor-pointer font-medium" i18n="@@adminEmployeeIdLabel">
          Request Admin Employee Name *
        </label>
      }

      <div class="group relative">
        <div class="relative">
          <input
            type="text"
            id="assignedToId"
            name="assignedToId"
            formControlName="employee"
            placeholder="Search by assigned employee"
            i18n-placeholder="@@searchEmployeeName"
            class="w-full rounded-[10px] border border-gray-400 bg-white py-2.5 text-[14px] text-gray-700 transition-colors outline-none placeholder:text-gray-300 hover:border-gray-600 focus:border-black ltr:pr-4 ltr:pl-10 rtl:pr-10 rtl:pl-4" />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="absolute top-1/2 h-5 w-5 -translate-y-1/2 text-gray-400 transition-colors group-focus-within:text-black group-hover:text-gray-600 ltr:left-3 rtl:right-3"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        </div>

        @if (assignForm.get("employee")?.invalid && assignForm.get("employee")?.touched) {
          @if (assignForm.get("employee")?.errors?.["required"]) {
            @if (context() === "approved-pharmacy") {
              <p class="text-sm font-light text-red-600" i18n="@@teleSalesRequired">
                Please select a Tele Sales representative.
              </p>
            } @else {
              <p class="text-sm font-light text-red-600" i18n="@@autoCompleteEmployeeRequired">
                Please select an Admin
              </p>
            }
          }
        }

        @if (activeDropDown()) {
          <div class="absolute z-[110] mt-1 max-h-52 w-full overflow-y-auto rounded-md border bg-white py-4 shadow-lg">
            @if (loadingEmployees()) {
              <app-loading />
            }
            @if (errorEmployees()) {
              <app-error [apiError]="isArabic() ? 'حدث بعض الخطأ' : 'some error occured'" />
            } @else {
              @if (employeeResults().length === 0 && !loadingEmployees()) {
                <p
                  i18n="@@noEmployeesData"
                  class="mx-auto flex w-full justify-center border-b border-gray-50 px-4 py-2 text-center text-start text-sm transition-colors last:border-0 hover:bg-gray-50">
                  No Employees matches this name
                </p>
              } @else {
                @for (item of employeeResults(); track item.id) {
                  <button
                    (click)="onSelectEmployee(item)"
                    class="block w-full cursor-pointer border-b border-gray-50 px-4 py-2 text-start text-sm transition-colors last:border-0 hover:bg-gray-100">
                    {{ item.fullName }}
                  </button>
                }
              }
            }
          </div>
        }
      </div>

      <div class="relative my-8 flex flex-col items-start">
        <label for="comments" class="text-primary mb-1 block cursor-pointer font-medium" i18n="@@comments">
          Comments
        </label>
        <textarea
          id="comments"
          formControlName="comment"
          placeholder="Write your comments here!"
          i18n-placeholder="@@commentsPlaceholder"
          class="focus-border-black-solid h-[8rem] w-full rounded-md border border-gray-300 bg-white px-3 py-2 hover:border-gray-400 focus:outline-none"></textarea>
        @if (assignForm.get("comment")?.invalid && assignForm.get("comment")?.touched) {
          @if (assignForm.get("comment")?.errors?.["maxlength"]) {
            <p class="text-sm font-light text-red-600">
              {{ isArabic() ? "التعليقات لا يمكن أن تتجاوز 4000 حرف" : "Comments cannot exceed 4000 characters" }}
            </p>
          }
        }
      </div>
    </div>

    @if (selectedEmployee()) {
      <div class="my-4 flex gap-3 rounded-lg border border-amber-200 bg-amber-50 p-4">
        <div class="shrink-0">
          <svg
            class="mt-0.5 h-5 w-5 text-amber-500"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor">
            <path
              fill-rule="evenodd"
              d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z"
              clip-rule="evenodd" />
          </svg>
        </div>
        <div class="flex flex-col gap-2">
          @if (type() === "assign") {
            <h3 class="font-semibold text-amber-800" i18n="@@warningAssignTitle">
              Are you sure you want to assign this employee?
            </h3>
            <p class="text-sm leading-relaxed text-amber-800" i18n="@@warningAssignDescription">
              The selected employee will be notified of this assignment.
            </p>
          }
          @if (type() === "re-assign") {
            <h3 i18n="@@warningTitle" class="font-semibold text-amber-800">
              Are you sure you want to reassign this request?
            </h3>
            <p i18n="@@warningDescription" class="text-sm leading-relaxed text-amber-800">
              The current employee will be notified of this change. Any pending modification requests will remain
              active.
            </p>
          }
        </div>
      </div>
    }

    <div class="flex flex-col gap-3">
      @if (errorAssign()) {
        <app-error [apiError]="errorAssign()" />
      }
      <div class="flex justify-end gap-3">
        <button
          (click)="onCancel()"
          class="border-primary text-primary hover-bg-primary-10 rounded-[6px] border px-4 py-2 font-[500] hover:cursor-pointer">
          <span i18n="@@adminCategoryFormButtonCancel">Cancel</span>
        </button>
        <button
          (click)="onSave()"
          [disabled]="!selectedEmployee()?.fullName || assignForm.get('comment')?.invalid"
          class="bg-primary hover-bg-primary-hover disabled-bg-disabled-bg disabled-text-disabled-text rounded-[6px] px-4 py-2 font-[500] text-white hover:cursor-pointer disabled:cursor-not-allowed">
          @if (loadingAssign()) {
            <span i18n="@@loading">loading</span>
          } @else {
            <span i18n="@@adminSaveButton">Save</span>
          }
        </button>
      </div>
    </div>
  </div>
</div>
